<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Value of Living Accomodations"
      text="Update value of living accomodation"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localVola.name"
                v-validate="'required'"
                label="Name"
                :error-messages="errors.collect('name')"    
                data-vv-name="name" 
                data-vv-as="name"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localVola.payroll_cycle_id"
                v-validate="'required'"
                :error-messages="errors.collect('payrollCycleId')"
                :items="payrollCycles"
                data-vv-name="payrollCycleId"     
                data-vv-as="payrollCycleId"
                item-text="name"
                item-value="id"
                value="id"
                label="Payroll Cycle"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="localVola.description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>
          </v-row>
        </v-container> 
      </form>  
    
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    props: {
      vola: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        dialog: false,
        progressing: false,
        localVola: null,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        payrollCycles: [],
      }
    },
    watch: {
      dialog (value) {
        if (!value) return this.$resetData()
        
        this.loading = true

        this.loadPayrollCycles()
        this.localVola = { ...this.vola }

        this.loading = false
      },
    },
    methods: {
      loadPayrollCycles () {
        this.$api.hrisPayrollCycles().list()
          .then(res => {
            this.payrollCycles = res.data
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.benefitInKinds().update(this.vola.id, this.prepareFormData())
              .then((res) => {
                this.$emit('updated')     
                this.$snack({ message: 'VOLA updated successfully' })

                this.progressing = false
                this.dialog = false
              })
              .catch(() => {
                this.progressing = false
              })
          })
      },   
   
      prepareFormData () {
        return {
          name: this.localVola.name,
          description: this.localVola.description,
          payroll_cycle_id: this.localVola.payroll_cycle_id,
        }
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>
